<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', width: 150, visible: true },
    {
      header: 'title' | translate,
      binding: 'description',
      width: '*',
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'customer',
    name: 'customers',
    filterChild: 'flat',
    form: 'CUSTOMER',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'SHIPPING_MANAGEMENT'"
  [moduleName]="'CUSTOMER_LIST'"
  [gridName]="'grdCustomerList'"
  [customFilter]="true"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
  [customFilterOutlet]="'CUSTOMER_DETAIL_FILTER'"
>
</kl-grid>
